import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/public/Login";
import Admin from "./pages/private/Admin";
import ProtectedRoute from "./utils/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import User from "./pages/private/User";
import { ThemeContextEditor } from "./styles/editor/ThemeContextEditor";
import EditorLayout from "./editor/selectaAdmin/LayoutEditor";
import DocumentPreviewPage from "./pages/private/DocumentPreviewPage";

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeContextEditor>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/client"
              element={
                <ProtectedRoute allowedRoles={["usuario"]}>
                  <User />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editor"
              element={
                <ProtectedRoute allowedRoles={["editor"]}>
                  <EditorLayout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/preview/:idDocument"
              element={
                <ProtectedRoute allowedRoles={["admin", "editor", "usuario"]}>
                  <DocumentPreviewPage />
                </ProtectedRoute>
              }
            />
            </Routes>
        </ThemeContextEditor>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
